export default __webpack_public_path__ + "static/media/img6.4d235c59.jpg";